import { useState, useEffect } from 'react';
import { Input } from '../ui/input';
import { Coins } from 'lucide-react';
import api from '../../lib/api';

const eur = (v, el) => `€${(v || 0).toLocaleString(el ? 'el-GR' : 'en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const CostTable = ({ title, rows, el, cols, testId }) => (
    <div className="flex-1 min-w-[280px]">
        <p className="text-sm font-semibold text-slate-700 mb-2">{title}</p>
        <table className="w-full text-sm" data-testid={testId}>
            <tbody>
                {rows.map((r) => (
                    <tr key={r.key} className="border-t border-slate-100">
                        {cols(r).map((c, i) => <td key={i} className={`py-1.5 ${i === 0 ? 'text-slate-800' : 'text-slate-500 text-xs'}`}>{c}</td>)}
                        <td className="py-1.5 text-right font-medium text-slate-800">{eur(r.total, el)}</td>
                    </tr>
                ))}
                {!rows.length && <tr><td className="py-2 text-slate-400 text-xs">{el ? 'Καμία ολοκληρωμένη συντήρηση' : 'No completed maintenance'}</td></tr>}
            </tbody>
        </table>
    </div>
);

export const MaintenanceCostsCard = ({ el }) => {
    const [month, setMonth] = useState(new Date().toLocaleDateString('sv-SE').slice(0, 7));
    const [data, setData] = useState(null);

    useEffect(() => {
        api.get(`/leasing/maintenance-costs?month=${month}`).then((r) => setData(r.data)).catch(() => setData(null));
    }, [month]);

    return (
        <div className="fleet-card p-5 space-y-4" data-testid="maintenance-costs-card">
            <div className="flex flex-wrap items-center justify-between gap-3">
                <div className="flex items-center gap-2">
                    <Coins className="w-5 h-5 text-[#1B7EB5]" />
                    <h2 className="text-base md:text-lg font-semibold text-slate-800">{el ? 'Κόστος συντήρησης' : 'Maintenance costs'}</h2>
                </div>
                <Input type="month" value={month} onChange={(e) => e.target.value && setMonth(e.target.value)} className="w-44" data-testid="maintenance-costs-month" />
            </div>
            {data && (
                <>
                    <div className="flex gap-8">
                        <div><p className="text-2xl font-bold text-[#1B7EB5]" data-testid="maintenance-costs-total">{eur(data.total, el)}</p><p className="text-xs text-slate-500">{el ? 'Σύνολο μήνα' : 'Month total'}</p></div>
                        <div><p className="text-2xl font-bold text-slate-800" data-testid="maintenance-costs-count">{data.count}</p><p className="text-xs text-slate-500">{el ? 'Ολοκληρωμένες' : 'Completed'}</p></div>
                    </div>
                    <div className="flex flex-wrap gap-6">
                        <CostTable title={el ? 'Ανά μισθωτή' : 'Per lessee'} el={el} testId="maintenance-costs-by-lessee"
                            rows={data.by_lessee.map((r) => ({ ...r, key: r.client_id }))} cols={(r) => [r.client_name, `${r.count}×`]} />
                        <CostTable title={el ? 'Ανά όχημα' : 'Per vehicle'} el={el} testId="maintenance-costs-by-vehicle"
                            rows={data.by_vehicle.map((r) => ({ ...r, key: r.vehicle_id }))} cols={(r) => [`${r.license_plate} ${r.vehicle}`, r.client_name]} />
                    </div>
                </>
            )}
        </div>
    );
};
